<div *ngIf="loading">
  <tmo-splash-page></tmo-splash-page>
</div>
<main class="inline" [hidden]="loading">
  <tmo-navbar
    *ngIf="!isNewHeaderFooterEnabled && aemContent && headerAEMData"
    pdlPageComponentId="NavbarComponent"
    [globalContent]="aemContent"
    [headerNavigationContent]="headerAEMData"
  ></tmo-navbar>
  <tmo-digital-navbar
    *ngIf="isNewHeaderFooterEnabled && aemContent && headerAEMData"
    pdlPageComponentId="NavbarComponent"
    [globalContent]="aemContent"
    [headerNavigationContent]="headerAEMData"
  ></tmo-digital-navbar>
  <div [hidden]="marketingData.show" class="container" tmoGoTopButton aria-live="polite">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
  <tmo-marketing [hidden]="!marketingData.show" [data]="marketingData"></tmo-marketing>
  <tmo-footer [footerData]="footerAEMData" *ngIf="footerAEMData"></tmo-footer>
</main>
<tmo-cart-not-empty-modal></tmo-cart-not-empty-modal>
<span class="hidden" id="interaction-id"> {{ interactionId }}</span>
<tmo-global-error-modal
  #webGlobalError
  [errorModalData]="errorModalData"
  (navigateToHome)="navigateToHome()"
></tmo-global-error-modal>
<pdl></pdl>
<!-- Web chat window: Do not modify the below id -->
<div id="lpButtonTelesales"></div>
<div tmoAutoLogin></div>
